import {Injectable} from '@angular/core';
import {TableRecordResult} from '../../../model/api/table-record-result';
import {SyncWsFacade, TableSyncWsService} from '../../websocket/table-sync-ws.service';
import {
  ClearingTableBaseWsAbsComponent
} from '../../../crystal-clear/clearing/table/clearing-table-base-ws-abs.component';

@Injectable({providedIn: 'root'})
export class ClearingTableSyncWsService extends TableSyncWsService<ClearingTableBaseWsAbsComponent> {

  protected override prepareNewRequest(component: ClearingTableBaseWsAbsComponent, newRequest: any, currentRequest: any): void {
    if (newRequest && currentRequest) {
      const standardFields = ['first', 'rows', 'sortField', 'sortOrder', 'multiSortMeta', 'filters', 'filters2', 'filters3', 'globalFilter', 'syncMetadata', 'originEvent'];
      Object.keys(currentRequest).forEach(key => {
        if (!standardFields.includes(key) && newRequest[key] === undefined && currentRequest[key] !== undefined) {
          newRequest[key] = currentRequest[key];
        }
      });
    }
  }

  protected override resolveWs(component: ClearingTableBaseWsAbsComponent): SyncWsFacade {
    return component.clearingWsService as unknown as SyncWsFacade;
  }

  protected override buildRequestIfNeeded(component: ClearingTableBaseWsAbsComponent): void {
    if (!component.tableCurrentRequest && component.tableConfig) {
      component.tableCurrentRequest = component.tableConfigService.constructRequest(
        component.tableConfig,
        component.tableCurrentRequest
      );
    }
  }

  protected override onDestroyTopicsExtra(component: ClearingTableBaseWsAbsComponent): void {
    component.recordIds = [];
    component.selectedIds = [];
  }

  protected override shouldReconstructRequestExtraFields(
    component: ClearingTableBaseWsAbsComponent,
    current: any,
    request: any
  ): boolean {
    return current.stateFilter !== request.stateFilter;
  }

  protected override afterReconstructRequest(
    component: ClearingTableBaseWsAbsComponent,
    request: any
  ): void {
    component.storeFilterSortStateToCookies?.(request);
  }

  protected override onAfterSyncApplied(
    component: ClearingTableBaseWsAbsComponent,
    tableResult: TableRecordResult
  ): void {
    const sync = tableResult.syncMetadata;

    component.recordIds = sync.recordIds;


    if (component.selectedIds?.length > 0) {
      const selectionLength = component.selectedIds.length;
      const recordIdsSet = new Set(sync.recordIds);
      component.selectedIds = component.selectedIds.filter(id => recordIdsSet.has(id));

      if (selectionLength != component.selectedIds.length) {
        component.refreshSelectionInfos();
      }
    }

    component.checkSyncIds();

    component.onSyncApplied?.();
  }

// Add field to the class
  private _syncInProgress = false;

  protected updateRecordsForSync(
    component: ClearingTableBaseWsAbsComponent,
    tableResult: TableRecordResult
  ): void {
    if (this._syncInProgress) {
      return;
    }
    this._syncInProgress = true;
    try {
      const sync = tableResult.syncMetadata;
      if (component.totalRecords > sync.totalRecord) {
        component.records.splice(
          component.totalRecords,
          component.totalRecords - sync.totalRecord
        );
      }
      //update scroll position if sync is at the end of the list
      if (component?.tableCurrentRequest?.first && sync.totalRecord <= component.tableCurrentRequest.first) {
        const scroller = component.ccTable.ccTable.scroller;
        const currentScrollLeft = scroller.contentEl?.scrollLeft || 0;
        component.ccTable.ccTable.scroller.scrollToIndex(sync.totalRecord - 1);
        setTimeout(() => {
          const contentElement = scroller.contentEl;
          if (contentElement) {
            contentElement.scrollLeft = currentScrollLeft;
          }
        });
      }
      super.updateRecordsForSync(component, tableResult);
    } finally {
      this._syncInProgress = false;
    }
  }

  private lastConfiguredTotalRecord = -1;

  protected override configureViewport(component: ClearingTableBaseWsAbsComponent): void {
    const total = component.totalRecords;
    if (total === this.lastConfiguredTotalRecord) {
      return;   // spacer height unchanged — no need to reinit the scroller
    }
    this.lastConfiguredTotalRecord = total;

    if (component.ccTable?.ccTable?.scroller) {
      component.ccTable.ccTable.scroller.autoSize = false;
      component.ccTable.ccTable.scroller.init();
    }

  }

  protected override loadList(component: ClearingTableBaseWsAbsComponent, result: TableRecordResult): void {
    const request: any = component.tableCurrentRequest;

    if (result.success) {
      component.applyRecordResult(result, request.first, request.first + request.rows);
    } else {
      component.errorMessage(result.message);
    }

    component.markForCheck();
    component.setNotLoading();
  }
}
